import React from "react";

export default function MarcasConfian({ marcas, titulo }) {
  return (
    <section className="w-full bg-white py-10 flex flex-col items-center justify-center">
      {titulo && (
        <h2 className="text-center text-xl md:text-2xl lg:text-3xl font-bold text-sidom-orange mb-8">
          {titulo}
        </h2>
      )}
      <div className="w-full max-w-6xl grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-y-8 gap-x-4 items-center justify-items-center">
        {marcas?.map((marca, idx) => (
          <img
            key={idx}
            src={marca.src}
            alt={marca.alt}
            className="max-h-16 md:max-h-20 max-w-[120px] object-contain"
            loading="lazy"
            draggable={false}
          />
        ))}
      </div>
    </section>
  );
}
